export default "__VITE_ASSET__CQmuoaAq__"